import styled from 'styled-components';

export const LabelStyled = styled.label`
  width: fit-content;
  height: fit-content;
`;
